// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__FyGnl","SearchInput":"Search_SearchInput__W6AF3"};